import React from 'react';

import { KeyboardShortcutContext, RegisterShortcutOptions } from '@neptune/shared/keyboard-domain';

const DEFAULT_OPTIONS: RegisterShortcutOptions = { disableOnModalOpen: true };

export const useKeyboardShortcut = (
  shortcut: string,
  callback: () => void,
  options = DEFAULT_OPTIONS,
) => {
  const { registerShortcut } = React.useContext(KeyboardShortcutContext);

  React.useEffect(() => {
    return registerShortcut(shortcut, callback, options);
  }, [callback, registerShortcut, shortcut, options]);
};
